import StandardRestError from './Standard'

class AlreadyMemberError extends StandardRestError {
  static CODE = 'ALREADY_ACCOUNT_MEMBER'

  constructor(
    message = 'User is already a member of this account.',
    status = 409,
    body = {},
  ) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default AlreadyMemberError
